export default "__VITE_ASSET__Be1jMz$h__"